import { Skeleton } from '@/_shared/components/ui/skeleton';

export function SlackCardSkeleton(): React.ReactElement {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card">
      <div className="flex items-center justify-between gap-3 px-4 py-4">
        <div className="flex min-w-0 items-center gap-3">
          <Skeleton className="size-10 shrink-0 rounded-lg" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-3 w-28" />
          </div>
        </div>
        <Skeleton className="h-9 w-20 shrink-0 rounded-lg" />
      </div>
      <div className="border-t border-border px-4 py-3">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-5 w-9 shrink-0 rounded-full" />
        </div>
      </div>
      <div className="border-t border-border px-4 py-3">
        <Skeleton className="h-4 w-28" />
        <div className="mt-2 space-y-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-5/6" />
          <Skeleton className="h-3 w-4/5" />
        </div>
      </div>
    </div>
  );
}

export function SlackTableSkeleton({ rows = 3 }: { rows?: number }): React.ReactElement {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="flex items-center gap-3 border-b border-border px-4 py-3 last:border-b-0">
          <Skeleton className="size-8 shrink-0 rounded-full" />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-24" />
          </div>
          <Skeleton className="h-3 w-16 shrink-0" />
        </div>
      ))}
    </div>
  );
}

export function SlackSectionSkeleton(): React.ReactElement {
  return (
    <div className="space-y-6">
      <SlackCardSkeleton />
      <div>
        <Skeleton className="mb-2 h-3 w-28" />
        <SlackTableSkeleton />
      </div>
      <div>
        <Skeleton className="mb-2 h-3 w-20" />
        <SlackTableSkeleton rows={2} />
      </div>
    </div>
  );
}
